import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomModal } from '../../shared/services/ziro-modal.service';
import { ButtonSizes, ButtonStyles, ZiroButtonComponent } from '../../button/button.component';
import { ZiroIcons } from '../../shared/models/ziro-icons.enum';
import { ToastTypes } from '../../shared/services/abstract/toast.service.abstract';
import { ToastService } from '../../shared/services/toast.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../shared/pipes/pipes.module';

interface ImportCertSuccessModalViewProperties {
  imgPath?: string;
}

@Component({
  selector: 'ziro-import-cert-success-modal',
  templateUrl: './import-cert-success-modal.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule, ZiroButtonComponent, PipesModule],
})
export class ImportCertSuccessModalComponent implements CustomModal<ImportCertSuccessModalViewProperties> {
  private activeModal = inject(NgbActiveModal);
  private _toastService = inject(ToastService);

  modalProperties: ImportCertSuccessModalViewProperties;
  buttonStyles = ButtonStyles;
  buttonSizes = ButtonSizes;
  ziroIcons = ZiroIcons;

  onButtonClick(): void {
    this.activeModal.close();
    this._toastService.push(
      ToastTypes.SUCCESS,
      this.ziroIcons.CERTIFICATE,
      'tkey;certificate_management.import_certificate.success_toast.title',
      'tkey;certificate_management.import_certificate.success_toast.message',
    );
  }
}
